export function orderHome(offerInfo, searchInfo, userInfo, houseInfo, orderId, params, bonusSystemValue = 0) {
    return axios({
        url: `/api/test/insurance/home/order/create`,
        method: 'post',
        data: {
            params: params,
            orderId: orderId,
            price: offerInfo.price,
            dynamicDiscountPrice:offerInfo.dynamicDiscountPrice,
            discountDetails:offerInfo.discountDetails,
            startDate: searchInfo.startDate,
            homeType: searchInfo.homeType,
            insuranceAmount: searchInfo.insuranceAmount,
            insurancePeriod: searchInfo.insurancePeriod,
            earnings: searchInfo.earnings,
            bonusSystemValue: bonusSystemValue,
            allowedDocuments: offerInfo.allowed_documents,
            info: {
                identificationCode: userInfo.identificationCode,
                withoutIdentificationCode: userInfo.withoutIdentificationCode,
                name_ua: userInfo.name_ua,
                surname_ua: userInfo.surname_ua,
                patronymic_ua: userInfo.patronymic_ua,
                dateBirth: userInfo.dateBirth,
                phone: userInfo.phone,
                mail: userInfo.mail,
                city: userInfo.city,
                street: userInfo.street,
                house: userInfo.house,
                apartment: userInfo.apartment,

                documentation: userInfo.documentation,
                documentType: userInfo.documentType,
                passportSerial: userInfo.passportSerial,
                passportNumber: userInfo.passportNumber,
                passportDate: userInfo.passportDate,
            },
            offerInfo:offerInfo,
            searchInfo:searchInfo,
            houseInfo: houseInfo,
        },
    });
}
